import React from "react";
import Slider from "react-slick";
import "./health.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaStar } from "react-icons/fa";
import doc1 from "../Assets/doc1.png"
import doc2 from "../Assets/doc2.png"
import doc4 from "../Assets/doc4.png"
import doc5 from "../Assets/doc5.png"
import doc6 from "../Assets/doc6.png"
import doc7 from "../Assets/doc7.png"
import doc8 from "../Assets/doc8.png"

// Custom Arrows
const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow left-arrow" onClick={onClick}>
    ❮
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="custom-arrow right-arrow" onClick={onClick}>
    ❯
  </div>
);

export default function HealthExperts() {
const doctors = [
  {
    image: doc1,
    name: "Dr. Amarender Reddy",
    spec: "General Medicine",
    degree: "MBBS, DNB (General Medicine), MNAMS",
    rating: 4.9,
  },
  {
    image: doc2,
    name: "Dr. Karunya",
    spec: "Paediatrics",
    degree: "MBBS, MD (Paediatrics)",
    rating: 4.8,
  },

  {
    image: doc4,
    name: "Dr. Hema Praveen",
    spec: "Obstetrics & Gynaecology",
    degree: "MBBS, DGO, MRCOG (UK), Diploma in Reproductive Medicine",
    rating: 5.0,
  },
  {
  image: doc5,
  name: "Dr. Srikanth D",
  spec: "Orthopaedics",
  degree: "MBBS, MS (Orthopaedics)",
  rating: 4.9,
},

{
  image: doc6,
  name: "C. Karthikeyudu",
  spec: "Nutrition & Dietetics",
  degree: "M.Sc (Nutrition and Dietetics)",
  rating: 4.8,
},
{
  image: doc7,
  name: "Dr. Durga Prasanna",
  spec: "Gynecology",
  degree: "MD (Gynecology), Diploma in Obstetrics and Gynecology",
  rating: 5,
},
{
  image: doc8,
  name: "Dr. K.R. Rao",
  spec: "General Surgery",
  degree: "Senior Consultant – General & Laparoscopic Surgeon, MS (General Surgery), DNB (General Surgery), FIAGES",
  rating: 5,
},

];


  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="expert-section">
      <div className="expert-header">
        <div>
          <h2 className="expert-title">Your Health in Expert Hands</h2>
          <p className="expert-subtitle">Meet The Experts Beyond Your Care</p>
        </div>
      </div>

      <div className="slider-wrapper">
        <Slider {...settings}>
          {doctors.map((doc, i) => (
            <div className="expert-card-wrapper" key={i}>
              <div className="expert-card">
                <img src={doc.image} alt={doc.name} className="expert-img" />
                <div className="expert-content">
                  <div className="d-flex justify-content-between">
                    <div className="expert-spec">{doc.spec}</div>
                    <div className="expert-rating">
                      <FaStar color="#ff3c00" size={14} /> {doc.rating}
                    </div>
                  </div>
                  <h3 className="expert-name">{doc.name}</h3>
                  <p className="expert-degree">{doc.degree}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
